<mat-toolbar class="content-header">
    <mat-icon fontIcon="manage_accounts"></mat-icon>

    <h1 class="page-title">{{'users.registry' | translate}}</h1>

    <span class="toolbar-spacer"></span>

    <lib-button (click)="editUser('')" color="primary" icon="add"
        tooltip="{{'users.add_user' | translate}}"></lib-button>

    <app-search-bar (searchText)="search($event)"></app-search-bar>
</mat-toolbar>

<ng-container>
    <div class="table-container">
        <table mat-table [dataSource]="usersData" matSort>
            <ng-container matColumnDef="user">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>
                    <div class="header-content">
                        <mat-icon fontIcon="account_circle" aria-hidden="true"></mat-icon>
                        User
                    </div>
                </th>

                <td mat-cell *matCellDef="let row">
                    <div class="user-info">
                        <p class="email">{{row.email}} </p>

                        <p class="name">{{row.firstName}} {{row.lastName}}</p>

                        <p class="company">{{row.company}}</p>
                    </div>
                </td>
            </ng-container>


            <ng-container matColumnDef="project">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>
                    <div class="header-content">
                        <mat-icon fontIcon="source" aria-hidden="true"></mat-icon>
                        Projects
                    </div>
                </th>

                <td mat-cell *matCellDef="let row" class="project-column">
                    <div *ngIf="row.projects" class="projects-container">
                        <mat-chip *ngFor="let project of row.projects"> {{project.name || project}} </mat-chip>
                    </div>
                </td>
            </ng-container>

            <ng-container matColumnDef="actions">
                <th mat-header-cell *matHeaderCellDef>
                    <div class="header-content">
                        <mat-icon fontIcon="edit" aria-hidden="true"></mat-icon>
                        Actions
                    </div>
                </th>

                <td mat-cell *matCellDef="let row">
                    <mat-checkbox [checked]="row.selected" (change)="onUserSelected($event, row)">
                        {{'form.selected'|translate}}</mat-checkbox>
                </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="usersColumns; sticky: true"></tr>
            <tr mat-row *matRowDef="let row; columns: usersColumns;"></tr>

            <tr class="mat-row no-data-row" *matNoDataRow>
                <td class="mat-cell" [attr.colspan]="usersColumns.length">
                    <lib-no-data message="form.search_no_data" description="form.search_no_data_desc" icon="search_off">
                    </lib-no-data>
                </td>
            </tr>
        </table>

        <div *ngIf="loading" class="table-overlay">
            <app-spinner></app-spinner>
        </div>

        <mat-paginator #userPaginator [length]="usersCount" [pageSize]="10" [pageSizeOptions]="[10, 25, 100]"
            class="paginator" (page)="handlePageEvent($event)">
        </mat-paginator>
    </div>
</ng-container>